import './css/fonts.scss';
import './css/vendors/swiper-bundle.min.scss';
import './css/vendors/fancybox.scss';
import './css/main.scss';
import Main from './js/main';
import fancybox from '@fancyapps/fancybox';

require('es6-promise').polyfill();

//window.readFile = Main.readFile;

Main.Init();
